import { render, staticRenderFns } from "./CertificateWarn.vue?vue&type=template&id=01cae09f&scoped=true&"
import script from "./CertificateWarn.vue?vue&type=script&lang=ts&"
export * from "./CertificateWarn.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateWarn.vue?vue&type=style&index=0&id=01cae09f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01cae09f",
  null
  
)

export default component.exports